module.exports = __webpack_public_path__ + "static/media/Blessed Midwest - Instrumental Version.fa22eafa.jpg";